{
  "text": "<p>This link is no longer active - but <strong>you can still make an appointment</strong></p><p><strong>Booking reference: <em>{{inviteId}}</em></strong><br/>(Quote this when you call.)</p><p>Please call our team and we'll help you get booked in:</p><a><strong>☎️ {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am–5pm.</p>",
  "title": "Your booking invitation has expired"
}
